import { useToast } from "@chakra-ui/react";
import { faVideo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import event from "../../../../lib/analytics";
import styles from "./ShareVideo.module.scss";
import { RECORD_DURATION_MS, isRecordingSupported, recordAquarium, shareOrDownload } from "./recordAquarium.js";

function track(name, params) {
    try { event(name, params); } catch { /* gtag may be blocked */ }
}

export default function ShareVideo({ aquariumRef }) {
    const toast = useToast();
    const { t } = useTranslation();
    const [progress, setProgress] = useState(null);
    const supported = useMemo(() => isRecordingSupported(), []);

    const onClick = useCallback(async () => {
        if (progress !== null) return;
        if (!supported) {
            toast({ description: t('shareVideoUnsupported'), status: 'warning', duration: 5000 });
            return;
        }
        track('share_video_started', { duration_seconds: RECORD_DURATION_MS / 1000 });
        setProgress(0);
        toast({ description: t('shareVideoRecording'), status: 'info', duration: 3000 });
        try {
            const { blob, mimeType } = await recordAquarium(aquariumRef, { onProgress: setProgress });
            const result = await shareOrDownload(blob, mimeType);
            track('share_video_completed', { method: result, mime_type: mimeType, size_kb: Math.round(blob.size / 1024) });
            if (result === "downloaded") toast({ description: t('shareVideoDownloaded'), status: 'success', duration: 4000 });
        } catch (e) {
            console.error(e);
            toast({ description: t(e?.message === "unsupported" ? 'shareVideoUnsupported' : 'shareVideoError'), status: 'error', duration: 5000 });
        } finally {
            setProgress(null);
        }
    }, [aquariumRef, progress, supported, t, toast]);

    return (
        <button type="button" className={styles.shareVideo} onClick={onClick} disabled={progress !== null}
                title={t('shareVideo')} aria-label={t('shareVideo')}>
            <FontAwesomeIcon icon={faVideo} size="lg" />
            <span>{progress === null ? t('shareVideo') : `${Math.round(progress * 100)}%`}</span>
        </button>
    );
}
